import { css } from 'styled-components';
import { kinds } from '../constant';
const ContrastStyle = css(["background-color:transparent;&:hover:not([disabled]),&:focus{background-color:var(--neutral-surface-inverse-hover);text-decoration:none;}&:active:not([disabled]){background-color:var(--neutral-surface-inverse-hover);}", " ", ""], _ref => {
  let {
    $kind
  } = _ref;
  return $kind === kinds.danger && css(["color:var(--danger-text-on-color);svg > *:not(defs),svg > *:not(defs) *{fill:var(--danger-icon);}&:hover:not([disabled]),&:focus{color:var(--danger-text-on-color-hover);}&:active:not([disabled]){color:var(--danger-text-on-color-hover);}"]);
}, _ref2 => {
  let {
    $kind
  } = _ref2;
  return $kind !== kinds.danger && css(["color:var(--primary-text-on-color);svg > *:not(defs),svg > *:not(defs) *{fill:var(--primary-icon);}&:hover:not([disabled]),&:focus{color:var(--primary-text-on-color-hover);svg > *:not(defs),svg > *:not(defs) *{fill:var(--primary-icon-hover);}}&:active:not([disabled]){color:var(--primary-text-on-color-hover);}"]);
});
export default ContrastStyle;